import { styled } from '../../config'

export const Spacer = styled('div', {
  flex: 1,
  justifySelf: 'stretch',
  alignSelf: 'stretch'
})
